export interface AttendanceQuery {
  passFromMs?: number;
  passToMs?: number;
  error?: string;
}

export function attendancePeriod(params: URLSearchParams): string {
  return params.get('period') || '30d';
}

/** Calendar dates use the browser's local time, as does dateTime in directory rows. */
function calendarDate(value: string): Date | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  if (year === undefined || month === undefined || day === undefined || year < 1970) return null;
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}

export function attendanceQuery(params: URLSearchParams, now: number): AttendanceQuery {
  const period = attendancePeriod(params);
  if (period === 'all') return {};
  if (period === 'custom') {
    const start = calendarDate(params.get('passFrom') ?? '');
    const end = calendarDate(params.get('passTo') ?? '');
    if (!start || !end) return { error: 'Укажите начало и конец периода проходов.' };
    if (start > end) return { error: 'Начало периода не может быть позже конца.' };
    end.setDate(end.getDate() + 1);
    return { passFromMs: start.getTime(), passToMs: end.getTime() };
  }
  const days = period === 'today' ? 1 : period === '7d' ? 7 : period === '30d' ? 30 : null;
  if (days === null) return { error: 'Выберите период проходов.' };
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  start.setDate(start.getDate() - days + 1);
  return { passFromMs: start.getTime(), passToMs: end.getTime() };
}

export function selectedPassSites(params: URLSearchParams): string[] {
  return [...new Set((params.get('passSites') ?? '').split(',').filter(Boolean))].sort();
}
